<template>
  <custom-dialog append-to-body width="65%" :title="model.title" :visible="visible" v-on="$listeners">
    <div style="padding: 0 24px">
      <div>
        <search-input width="100%" :placeholder="$t('s_department1_bmmc')" v-model="appKey"></search-input>
        <div style="padding: 24px 0; min-height: 537px">
          <custom-tree
            ref="tree"
            check-strictly
            show-checkbox
            default-expand-all
            :default-checked-keys="defaultCheckedKeys"
            node-key="bizId"
            :data="organTree"
            :props="{ label: 'bizName' }"
            :expand-on-click-node="false"
            :listener="appKey"
            :filterKeys="['bizName']"
          >
            <template slot="label" slot-scope="scope">{{ scope.node.label }}</template>
          </custom-tree>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="saveOrganGroup">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTree from '@/components/customTree.vue';

// s_department1_bmmc: 部门名称

export default {
  mixins: [dialogMixins],
  components: { customTree },
  data() {
    return {
      appKey: '',
      defaultCheckedKeys: [],
      organTree: [],
    };
  },
  mounted() {
    this.mergeLanguage(null, 'portal_select_department_dialog');
    this.getOrganTree();
  },
  methods: {
    // 获取部门树
    getOrganTree: function () {
      this.defaultCheckedKeys = this.model.defaultCheckedKeys;
      this.$getJSON(apis.DepartmentTree, { orgId: this.model.orgId }).then((res) => {
        this.organTree = [{ disabled: true, ...res.data }];
      });
    },
    // 关联项目、部门
    saveOrganGroup: function () {
      this.visible = false;
      const arr = this.$refs.tree.getCheckedNodes();
      const bizIds = arr.map(t => t.bizId);
      const list = arr.filter(t => [...bizIds, ...t.bizPath.split('/').slice(0, -1)].length === [...new Set([...bizIds, ...t.bizPath.split('/').slice(0, -1)])].length);
      this.$emit(
        'success',
        list.map(t => ({ toBizType: t.bizType, orgId: this.model.orgId, bizId: t.bizId, bizName: t.bizName }))
      );
    },
  },
};
</script>

<style lang="scss"></style>
